import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

const useInsightsUserPurchases = (onlyFansUserId: number | null | undefined, cursorDate?: Date) => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();

    const fetchData = async (): Promise<any | null> => {
        const query: string = `${settingsContext.routes.sextforce.base}${subscriber._id}/onlyFansUsers/${onlyFansUserId}/media/sales`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return null;
            });
    };

    const query = useQuery(['insightsUserPurchases', onlyFansUserId, cursorDate], () => fetchData(), {
        refetchOnWindowFocus: false,
        refetchInterval: 1000 * 60 * 5, // 5 minutes
        enabled:
            userContext.jwtToken && settingsContext.apiKey && userContext.isAdmin && subscriber && subscriber._id && onlyFansUserId
                ? true
                : false,
    });

    return { ...query };
};

export default useInsightsUserPurchases;
